// src/services/firebase/portfolioService.js
import { doc, getDoc, setDoc, collection, getDocs, deleteDoc, writeBatch } from 'firebase/firestore';
import { db } from './config';

export const savePortfolioTargets = async (userEmail, data, selectedPortfolioId = 'default') => {
  if (!userEmail) throw new Error('Email gerekli');
  
  try {
    const batch = writeBatch(db);
    const portfolioRef = collection(db, 'users', userEmail, 'portfolios', selectedPortfolioId, 'portfolio');
    
    Object.entries(data).forEach(([key, value]) => {
      const docRef = doc(portfolioRef, key);
      batch.set(docRef, {
        ...value,
        name: key,
        updatedAt: new Date(),
        lastModifiedBy: userEmail
      });
    });

    await batch.commit();
    return true;
  } catch (error) {
    console.error('Portfolio kaydetme hatası:', error);
    throw error;
  }
};

export const getPortfolioTargets = async (userId, selectedPortfolioId = 'default') => {
  if (!userId) throw new Error('User ID is required');

  try {
    const portfolioRef = collection(db, 'users', userId, 'portfolios', selectedPortfolioId, 'portfolio');
    const snapshot = await getDocs(portfolioRef);
    
    const portfolioData = {};
    snapshot.forEach(doc => {
      portfolioData[doc.id] = doc.data();
    });
    return portfolioData;
  } catch (error) {
    console.error('Portfolio getirme hatası:', error);
    throw new Error(error.message || 'Portfolio verileri getirilemedi');
  }
};

export const updateCategory = async (userId, categoryId, categoryData, selectedPortfolioId = 'default') => {
  if (!userId || !categoryId) throw new Error('User ID and category ID are required');

  try {
    // Veri doğrulama
    if (typeof categoryData !== 'object') {
      throw new Error('Invalid category data format');
    }

    const docRef = doc(db, 'users', userId, 'portfolios', selectedPortfolioId, 'portfolio', categoryId);
    await setDoc(docRef, {
      ...categoryData,
      updatedAt: new Date(),
      lastModifiedBy: userId
    });
    console.log('Category updated successfully:', categoryId);
    return true;
  } catch (error) {
    console.error('Kategori güncelleme hatası:', error);
    throw new Error(error.message || 'Kategori güncellenirken bir hata oluştu');
  }
};

export const deleteCategory = async (userId, categoryId, selectedPortfolioId = 'default') => {
  if (!userId || !categoryId) throw new Error('User ID and category ID are required');

  try {
    const docRef = doc(db, 'users', userId, 'portfolios', selectedPortfolioId, 'portfolio', categoryId);
    await deleteDoc(docRef);
    console.log('Category deleted successfully:', categoryId);
    return true;
  } catch (error) {
    console.error('Kategori silme hatası:', error);
    throw new Error(error.message || 'Kategori silinirken bir hata oluştu');
  }
};

export const getUserData = async (userId, selectedPortfolioId = 'default') => {
  if (!userId) throw new Error('User ID is required');

  try {
    const docRef = doc(db, 'users', userId, 'portfolios', selectedPortfolioId, 'settings', 'rebalance');
    const snapshot = await getDoc(docRef);
    return snapshot.exists() ? snapshot.data() : {};
  } catch (error) {
    console.error('Kullanıcı verisi getirme hatası:', error);
    throw new Error(error.message || 'Kullanıcı verileri getirilemedi');
  }
};

export const updateRebalanceSettings = async (userId, settings, selectedPortfolioId = 'default') => {
  if (!userId) throw new Error('User ID is required');
  if (!settings || typeof settings !== 'object') {
    throw new Error('Invalid settings format');
  }

  try {
    const docRef = doc(db, 'users', userId, 'portfolios', selectedPortfolioId, 'settings', 'rebalance');
    await setDoc(docRef, {
      ...settings,
      updatedAt: new Date()
    }, { merge: true });
    console.log('Rebalance settings updated successfully');
    return true;
  } catch (error) {
    console.error('Rebalance ayarları güncelleme hatası:', error);
    throw new Error(error.message || 'Rebalance ayarları güncellenirken bir hata oluştu');
  }
};